module.exports = __webpack_public_path__ + "img/f25a1ac.jpg";